import { EmailInUseError, UnexpectedError } from "../../../domain/errors";
import { GetCellphonesByStatus } from "../../../domain/usecases/get-cellphones-by-status";
import { HttpClient, HttpStatusCode } from "../../protocols/http";

export class RemoteGetCellphonesByStatus implements GetCellphonesByStatus {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<RemoteGetCellphonesByStatus.Model>
  ) {}

  async fetch(
    params: GetCellphonesByStatus.Params
  ): Promise<RemoteGetCellphonesByStatus.Model> {
    console.log("body: params,", params);

    const httpResponse = await this.httpClient.request({
      url: this.url,
      method: "post",
      body: params,
    });
    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body!;
      case HttpStatusCode.forbidden:
        throw new EmailInUseError();
      default:
        throw new UnexpectedError();
    }
  }
}

export namespace RemoteGetCellphonesByStatus {
  export type Model = GetCellphonesByStatus.Model;
}
